import { render } from "./DeliveriesList.vue?vue&type=template&id=98de9894&scoped=true"
import script from "./DeliveriesList.vue?vue&type=script&lang=js"
export * from "./DeliveriesList.vue?vue&type=script&lang=js"

import "./DeliveriesList.vue?vue&type=style&index=0&id=98de9894&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Isaias\\Documents\\Vue\\EntregasApp\\Lupnova\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98de9894"]])

export default __exports__